<template>
  <v-card
    class="elevation-3 pa-4 my-4 track-card p-4"
    color="white"
  >
    <v-row align="center" no-gutters>
      <v-col cols="auto">
        <v-icon color="primary" class="material-icons-outlined __shake" size="36">
          directions_car
        </v-icon>
      </v-col>

      <v-col class="pl-3">
        <h3 class="text-subtitle-1 font-weight-medium mb-1">
          {{  $t("section.tracking.trackingToday") }} 
        </h3>
        <p class="text-body-2 grey--text" color="primary">
          {{  $t("section.tracking.trackRideMsg") }} 
        </p>
      </v-col>
    </v-row>

   
    <v-btn
      color="secondary"
      style="color: #4F39CF !important;font-weight: bold !important;"
      block
      large
      @click="trackRide(ride.id)"
    >
      <v-icon left class="material-icons-outlined">map</v-icon>
      {{ $t("section.tracking.goToTracking") }}
    </v-btn>
    
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    ride: Object
  },
  data(){
    return{
    }
  },
  methods: {
    ...mapActions("service", ["_openTracking"]),
    ...mapActions("global", ["_hideIntercomLauncher"]),
    isServiceToday(date) {
      console.log(date);
      // Always true for now, replace with actual check
      return true

      // Uncomment for real logic:
      // const today = new Date().toISOString().split('T')[0]
      // const rideDate = new Date(date).toISOString().split('T')[0]
      // return today === rideDate
    },
    trackRide(rideId) {
      setTimeout(() => {
        this._openTracking(rideId);
      }, 500);
     
    }
  }
}
</script>

<style scoped>
.track-card {
  border-radius: 12px;
  margin: 25px;
  margin-bottom: -20px !important;
}
.__shake {
    animation: wiggle 2s linear infinite;
}
@keyframes wiggle {
    0%,
    7% {
        transform: rotateZ(0);
    }
    15% {
        transform: rotateZ(-15deg);
    }
    20% {
        transform: rotateZ(10deg);
    }
    25% {
        transform: rotateZ(-10deg);
    }
    30% {
        transform: rotateZ(6deg);
    }
    35% {
        transform: rotateZ(-4deg);
    }
    40%,
    100% {
        transform: rotateZ(0);
    }
}
</style>
